import CryptoJS from 'crypto-js';
// import * as navigation from 'app_common/interface/Navigation';
import RootStore from '@stores';
import { getMessageByCode } from './errorMap';
// import AppInsights from 'app_common/utils/applicationInsight';
import i18n from '@translate/i18n';
import { StringKeyObject } from '@interfaces/app';
import AppInsights from './applicationInsight';

type TAsyncFunc = () => any;
type TPromise = Promise<any>;
/**
 * api errorCaptured
 * @param asyncFunc
 */
export async function errorCaptured(asyncFunc: TAsyncFunc | TPromise) {
    try {
        let res: any;
        if (asyncFunc instanceof Promise) {
            res = await asyncFunc;
        } else {
            res = await asyncFunc();
        }
        return [null, res.data];
    } catch (err: any) {
        let code = err.code || err?.response?.data?.code || err?.status;
        const message = getMessageByCode(code);
        try {
            if (typeof err !== 'string') err.message = message;
        } catch (error) {
            console.log('error', error);
        }
        return [err, null];
    }
}

/**
 * 加密字符串 -》 base64
 * @param rawStr source string
 */
export const base64Encode = (rawStr: string) => {
    var wordArray = CryptoJS.enc.Utf8.parse(rawStr);
    return CryptoJS.enc.Base64.stringify(wordArray);
};

/**
 * 解密 base64 -》 string
 * @param base64
 */
export const base64Decode = (base64: string) => {
    try {
        if (base64 === undefined) return '';
        const parsedWordArray = CryptoJS.enc.Base64.parse(base64);
        var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8);
        return parsedStr;
    } catch (e) {
        console.warn('Invalid base64 ' + base64);
        return '';
    }
};

// function decodeBase64(encodedValue) {
//     if (encodedValue === null) {
//         return null;
//     }
//     // 确保encodedValue是有效的Base64字符串
//     if (!/^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(encodedValue)) {
//         throw new Error('Invalid Base64 string');
//     }
//     // 将Base64字符串解码为二进制字符串
//     let binary_string = atob(encodedValue);
 
//     // 使用TextDecoder（如果binary_string包含非ASCII字符，这将确保正确解码）
//     let decoder = new TextDecoder('utf-8'); // 明确指定解码为UTF-8
//     let decodedValue = decoder.decode(new Uint8Array(binary_string.split('').map(c => c.charCodeAt(0))));
 
//     return decodedValue;
// }

/**
 * 點解返回頂部按鈕 平滑返回頂部
 * @param element 滾動元素
 */
export const onClickBackTop = (element: any) => {
    if (!element) return;
    let scrollTop = element.scrollTop;
    // 清空上一次的定时器
    // 创建定时器，每 15ms 执行一次箭头函数
    let timer = setInterval(() => {
        // 每次执行函数，scrollTop 减少十分之一
        scrollTop -= scrollTop / 10;
        element.scrollTo(0, scrollTop);
        // 当 scrollTop 小于 2 时，直接使 scrollTop 为 0，并且清空定时器。
        if (scrollTop < 2) {
            element.scrollTo(0, 0);
            clearInterval(timer);
        }
    }, 15);
};

export function setCookie(cname: any, cvalue: any, exmins?: number) {
    var d = new Date(),
        expires = 'expires=';
    if (exmins) {
        d.setTime(d.getTime() + exmins * 60 * 1000);
        expires += d.toUTCString();
    }
    document.cookie = cname + '=' + cvalue + '; ' + expires;
}

export function getCookie(cname: any) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export const parseJwt = (token:string) => {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
        atob(base64)
        .split("")
        .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
};

export const checkEmptyString = (txt: string | undefined | null) => {
    if (typeof txt === 'string') txt = txt.trim();
    return (
        txt === '' ||
        !txt ||
        txt === null ||
        txt === 'null' ||
        txt === 'NULL' ||
        txt === undefined ||
        txt === 'undefined' ||
        txt === 'none' ||
        txt === 'non' ||
        txt === 'NA' ||
        txt === 'nil' ||
        txt === '-'
    );
};

export const isOpenByMyHKBNApp = navigator.userAgent.indexOf('MyHKBNApp') > -1;

export const AppInsightLog = new AppInsights('MyHKBN Webbundle - online-campaign');

/**
 * Google analyze
 * @param params
 */
export const utag = (params: StringKeyObject<any>, view?: boolean) => {
    const utag = (window as any).utag;
    const languages = i18n.language;
    try {
        if (!utag) return;
        if (view) {
            return utag.link({
                ...params,
                languages,
            });
        }
        utag.link({
            ...params,
            languages,
        });
    } catch (err) {
        console.log('GA tracking error', err);
    }
};


export const descriptionFormat = (desc: string) => {
    if (!desc) return [];
    const descriptions = desc
        .replace(/\\n\\n/g, '<br/>')
        .replace(/\\n/g, '<br/>')
        .replace(/\n\n/g, '<br/>')
        .replace(/\n/g, '<br/>')
        .split('<br/>');

    return descriptions;
};
